<template>
    <div class="q-gutter-y-md" style="min-width: 100%; height:80px; margin-top:5px">
      <q-tabs v-model="tab" outside-arrows mobile-arrows no-caps indicator-color="primary" >
      <div style="margin-right:20px">
        <q-tab name="all" @click="goTo('all')">
        <img :src="require(`@/assets/red2/All.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        All Products
        </q-tab>
      </div>
     <div style="margin-right:20px">
        <q-tab name="training" @click="goTo('ICPhome')">
        <img :src="require(`@/assets/red2/ICPhome.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        ICP Home
        </q-tab>
      </div>
      <div style="margin-right:20px">
        <q-tab name="training" @click="goTo('training')">
        <img :src="require(`@/assets/red2/Training.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Training
        </q-tab>
      </div>
      <div style="margin-right:20px">
        <q-tab name="equipment" @click="goTo('equipment')">
        <img :src="require(`@/assets/red2/Equipment.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Equipment
        </q-tab>
      </div>
      <div style="margin-right:20px">
        <q-tab name="holds" @click="goTo('holds')">
        <img :src="require(`@/assets/red2/Holds.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Holds
        </q-tab>
      </div>
      <div style="margin-right:20px">
        <q-tab  name="macros" @click="goTo('macros')">
        <img :src="require(`@/assets/red2/Macros.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Macros
        </q-tab>
      </div>
      <div style="margin-right:20px">
        <q-tab name="screws" @click="goTo('screws')">
        <img :src="require(`@/assets/red2/Screws.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Screws
        </q-tab>
      </div>
      <div style="margin-right:20px">
        <q-tab name="volumes" @click="goTo('volumes')">
        <img :src="require(`@/assets/red2/Volumes.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Volumes
        </q-tab>
      </div>
      <div>
        <q-tab  name="kids" @click="goTo('kids')">
        <img :src="require(`@/assets/red2/Kids.svg`)" alt="img" height='60' style="padding:0; margin:0; "/>
        Kids Holds
        </q-tab>
      </div>
      </q-tabs>
    </div>
</template>


<script>

export default {
  name: 'ProductCategoryFilter',
  computed: {
  },
  data(){
    return{
        tab:"all",
        colour:"red",
        clicks:0,
    }
  },
  methods: {
    goTo(option){  
      let selection = 'All Products'
      this.$store.commit('filters/clearFilters')
      console.log('type', this.$store.state.cart.currentStoreType);
      
      if(option == 'training'){
        selection = "Training"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiVHJhaW5pbmcgUHJvZHVjdHMiXX1d')
      }else if(option == 'equipment'){
        selection = "Equipment"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiQ2xpbWJpbmcgRXF1aXBtZW50Il19XQ%3D%3D')
      }else if(option == 'holds'){
        selection = "Holds"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiSG9sZCJdfV0%3D')
      }else if(option == 'macros'){
        selection = "Macros"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiTWFjcm8iXX1d')
      }else if(option == 'screws'){
        selection = "Screws"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiU2V0dGluZyBIYXJkd2FyZSJdfV0%3D')
      }else if(option == 'volumes'){
        selection = "Volumes"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiV29vZGVuIFZvbHVtZSIsIkZpYmVyZ2xhc3MgVm9sdW1lIl19XQ%3D%3D')
      }else if(option == 'ICPhome'){
        selection = "ICP Home"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiSUNQIEhvbWUiXX1d')
      }else if(option == 'kids'){
        selection = "Kids"
        this.$router.push(this.$route.path + '?filters=W3sidHlwZSI6InR5cGUiLCJ2YWx1ZXMiOlsiS2lkcyJdfV0%3D')
      }
      //Tracker
      analytics.track("Category Filter Selection", {
        category: selection,
        storeType: this.$store.state.cart.currentStoreType
      });
    },
  }
}
</script>

<style scoped lang="stylus">
@import '~quasar-variables';

>>>.q-tabs__arrow {
    padding-top:30px
}
>>>.q-tabs__arrow--left {
    border-right:1px solid silver
    height: 70px
    margin-top:10px
}

>>>.q-tabs__arrow--right {
    border-leftx:1px solid silver
    height: 70px
    margin-top:10px
}

</style>


